import { useContext } from 'react'

import DaiChatContext from 'contexts/DaiChatContext'

const useDaiChat = () => {
  const context = useContext(DaiChatContext)

  if (context === undefined) {
    throw new Error('useDaiChat must be used within a DaiChatContext.Provider')
  }

  return {
    // Controle do painel
    chatOpen: context.chatOpen ?? false,
    agentName: context.agentName,
    chatContext: context.chatContext ?? {},
    initialMessage: context.initialMessage ?? null,
    handleOpenChat: context.handleOpenChat ?? (() => {}),
    handleNewChat: context.handleNewChat ?? (() => {}),
    handleOpenChatPanel: context.handleOpenChatPanel ?? (() => {}),
    handleCloseChat: context.handleCloseChat ?? (() => {}),
    newChatDialogOpen: context.newChatDialogOpen ?? false,
    confirmNewChat: context.confirmNewChat ?? (() => {}),
    cancelNewChat: context.cancelNewChat ?? (() => {}),
    // Estado da instância
    daiChat: context.daiChat ?? null,
    userName: context.userName ?? null,
    messages: context.messages ?? [],
    loading: context.loading ?? false,
    isSending: context.isSending ?? false,
    inputMessage: context.inputMessage ?? '',
    hasMessage: context.hasMessage ?? false,
    // Refs
    messagesContainerRef: context.messagesContainerRef ?? { current: null },
    chatContainerRef: context.chatContainerRef ?? { current: null },
    inputRef: context.inputRef ?? { current: null },
    // Ações
    sendMessage: context.sendMessage ?? (() => {}),
    abortMessage: context.abortMessage ?? (() => {}),
    setInputMessage: context.setInputMessage ?? (() => {}),
    registerMixpanelEvent: context.registerMixpanelEvent ?? (() => {}),
  }
}

export default useDaiChat
